export default __webpack_public_path__ + "static/media/eye_off.e7c60959.svg";